export const reportReasonsConstants = {

    GETALLREPORT_REASONS_REQUEST: 'SPARKS_GETALL_REPORT_REASONS_REQUEST',
    GETALLREPORT_REASONS_SUCCESS: 'SPARKS_GETALL_REPORT_REASONS_SUCCESS',
    GETALLREPORT_REASONS_FAILURE: 'SPARKS_GETALL_REPORT_REASONS_FAILURE',

};
